import { render, staticRenderFns } from "./TopicCongress.vue?vue&type=template&id=1a9c3962&scoped=true"
import script from "./TopicCongress.vue?vue&type=script&lang=js"
export * from "./TopicCongress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c3962",
  null
  
)

export default component.exports